module.exports = __webpack_public_path__ + "img/ph_trunk.1c27c43c.jpg";